import { render } from "./AddContact.vue?vue&type=template&id=b8027992"
import script from "./AddContact.vue?vue&type=script&lang=js"
export * from "./AddContact.vue?vue&type=script&lang=js"
script.render = render

export default script